export function formatDateTime(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZone: 'Asia/Kolkata',
  });
}

export function formatDateTimeShort(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('en-IN', {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZone: 'Asia/Kolkata',
  });
}

/** datetime-local value → ISO UTC for API (preserves user's local pick) */
export function localInputToISO(value) {
  if (!value) return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString();
}

export function toLocalInput(value) {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  const parts = new Intl.DateTimeFormat('en-CA', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: 'Asia/Kolkata',
  }).formatToParts(d);
  const get = (type) => parts.find((p) => p.type === type)?.value || '';
  return `${get('year')}-${get('month')}-${get('day')}T${get('hour')}:${get('minute')}`;
}

export const TYPE_COLORS = {
  bug: 'bg-red-500/20 text-red-300',
  feature: 'bg-teal-500/20 text-teal-300',
  incident: 'bg-orange-500/20 text-orange-300',
  maintenance: 'bg-blue-500/20 text-blue-300',
  chore: 'bg-slate-500/20 text-slate-300',
};

export const STATUS_COLORS = {
  pipeline: 'bg-violet-600',
  pending: 'bg-slate-600',
  in_progress: 'bg-blue-600',
  completed: 'bg-emerald-600',
  blocked: 'bg-red-600',
};

export function formatDurationMinutes(minutes) {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (h && m) return `${h} hr ${m} min`;
  if (h) return `${h} hr${h !== 1 ? 's' : ''}`;
  return `${m} min`;
}

export function liveEntryMinutes(startedAt) {
  if (!startedAt) return 0;
  const ms = Date.now() - new Date(startedAt).getTime();
  if (ms < 0) return 0;
  return Math.floor(ms / 60000);
}

export const PRIORITY_COLORS = {
  low: 'bg-emerald-600',
  medium: 'bg-amber-600',
  high: 'bg-orange-600',
  critical: 'bg-red-600',
};
